<template>
  <div class="administrador">
    <div class="d-flex justify-content-center m-5">
      <h4 class="titulo-admin">!Bienvenido, administrador¡</h4>
    </div>
    <!--Nuevo Usuario-->
    <div v-if="editarMaster" class="d-flex justify-content-center m-5">
      <button
        class="boton-primario px-5 py-2 me-4"
        @click.prevent="nuevoPerfil()"
      >
        <i class="fas fa-solid fa-user-plus me-2"></i>
        Dar de alta nuevo perfil
      </button>
    </div>
    <!--Seleccion Tipo Usuario-->
    <div class="d-flex justify-content-center m-5">
      <button
        class="boton-primario px-5 py-2 me-4"
        @click.prevent="SeleccionaTipoUsuario('M')"
      >
        <i class="fas fa-solid fa-user-plus me-2"></i>
        Masters
      </button>
      <button
        class="boton-primario px-5 py-2 me-4"
        @click.prevent="SeleccionaTipoUsuario('P')"
      >
        <i class="fas fa-solid fa-user-plus me-2"></i>
        Prospectos
      </button>
    </div>
    <!--Busqueda-->
    <div class="container d-flex justify-content-center">
      <!--Busqueda Texto-->
      <div class="w-50 wrapper-busqueda">
        <input
          type="text"
          class="form-control campo-administracion"
          placeholder="Buscar por nombre"
          v-model="textoBusqueda"
        />
        <i class="fas fa-search icono-busqueda"></i>
      </div>
    </div>
    <!--Busqueda Proyecto-->
    <div class="container d-flex justify-content-center">
      <div class="w-50">
        <DropDown
          placeholder="Selecciona una sucursal"
          :arreglo="proyectos"
          llave="proyectoVentaId"
          valor="proyectoVentaId"
          texto="nombre"
          v-model="proyecto"
          class="dropdown"
        ></DropDown>
      </div>
    </div>
   <!--Listado Masters-->
    <v-row class="d-flex justify-center my-5 mx-2" v-if="editarMaster">
      <v-col cols="12" sm="10">
        <v-data-table
          :headers="headersMasters"
          :items="masters"
          :items-per-page="15"
          :loading="cargandoMasters"
          loading-text="Cargando..."
        >
          <template v-slot:item.nombre="{ item }">
            <v-btn
              text
              class="font-weight-bold"
              @click="editarPerfil(item.id, 'M')"
            >
              {{ item.nombre.toUpperCase() }}
            </v-btn>
          </template>
          <template v-slot:item.estatus="{ item }">
            <v-btn
              rounded
              outlined
              :class="
                item.estatus == 'ACTIVO' ? 'estatus-activo' : 'estatus-inactivo'
              "
              @click="habilitarMaster(item.id, item.estatus)"
            >
              {{ item.estatus }}
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!--Listado Prospectos-->
    <v-row class="d-flex justify-center my-5 mx-2" v-else>
      <v-col cols="12" sm="10">
        <v-data-table
          :headers="headersProspectos"
          :items="prospectos"
          :items-per-page="15"
          :header-props="{ 'text-transform': 'uppercase' }"
          :loading="cargandoProspectos"
          loading-text="Cargando..."
        >
          <template v-slot:item.nombre="{ item }">
            <v-btn
              text
              class="font-weight-bold"
              @click="editarPerfil(item.usuarioId, 'P')"
            >
              {{ item.nombre.toUpperCase() }}
            </v-btn>
          </template>
          <template v-slot:item.token="{ item }">
            <v-btn
              rounded
              outlined
              :class="
                item.token == 'Vigente' ? 'estatus-activo' : 'estatus-inactivo'
              "
              @click="habilitarToken(item.usuarioId, item.token)"
            >
              {{ item.token }}
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
// Componentes
import axios from "axios";
import DropDown from "../../Prospecto/components/DropDown.vue";
//Rutas de api
var rutaListarProspectosPorRol = "/api/Master/Prospecto/ListarProspectosPorRolAdmin";
var rutaListarMasters = "/api/Master/Master/ListarMastersAdminUsuarios";
var rutaActualizaUsuario = "/api/Master/Master/ActualizarEstatusUsuario";
var rutaActualizarTokenUsuario = "/api/Master/Master/ActualizarTokenUsuario";
var rutaListarProyectos = "/api/Master/Master/ListarProyectos";

export default {
  name: "Administrador",
  data() {
    return {
      masters: [],
      prospectos: [],
      masterId: this.$store.getters.masterId,
      ordenAscNombre: false,
      ordenAscGerencia: false,
      ordenAscRegion: false,
      ordenAscCorreo: false,
      ordenAscEstatus: false,
      ordenAscNombrePros: false,
      ordenAscEtapaPros: false,
      ordenAscRegionPros: false,
      ordenAscCorreoPros: false,
      ordenAscEstatusPros: false,
      proyectoVentaId: null,
      proyectos: [],
      proyecto: null,
      tipoUsuario: null,
      textoBusqueda: "",
      editarMaster: true,
      headersMasters: [
        {
          text: "Nombre",
          align: "start",
          sortable: true,
          value: "nombre",
        },
        {
          text: "Gerencia",
          value: "gerencia",
          sortable: true,
          align: "start",
          color: "red",
        },
        { text: "Región", value: "region", sortable: true, align: "start" },
        { text: "Correo", value: "correo", sortable: true, align: "start" },
        { text: "Estatus", value: "estatus", sortable: true, align: "center" },
      ],
      headersProspectos: [
        {
          text: "Nombre",
          align: "start",
          sortable: true,
          value: "nombre",
        },
        {
          text: "Región",
          value: "sucursal",
          sortable: true,
          align: "start",
          color: "red",
        },
        {
          text: "Etapa",
          value: "aliasEtapaStr",
          sortable: true,
          align: "start",
        },
        { text: "Correo", value: "usuario", sortable: true, align: "start" },
        { text: "Estatus", value: "token", sortable: true, align: "center" },
      ],
      cargandoMasters: false,
      cargandoProspectos: false,
    };
  },
  components: {
    DropDown,
  },
  computed: {
    // mastersFiltrados() {
    //   if (this.textoBusqueda == "") {
    //     if(this.masters.length < 1)
    //     {
    //      this.listarMasters();
    //     }
    //       return this.masters;
    //   } else {
    //     let arregloPalabras = this.textoBusqueda
    //       .split(/[ ,]+/)
    //       .filter((f) => f.length);
    //     return this.masters.filter((master) => {
    //       let nombre = master.nombre;
    //       return arregloPalabras.some((p) => nombre.includes(p.toUpperCase()));
    //     });
    //   }
    // },
    // prospectosFiltrados() {
    //   if (this.textoBusqueda == "") {
    //        if(this.prospectos.length < 1)
    //     {
    //      this.listarProspectos();
    //     }
    //     return this.prospectos;
    //   } else {
    //     let arregloPalabras = this.textoBusqueda
    //       .split(/[ ,]+/)
    //       .filter((f) => f.length);
    //     return this.prospectos.filter((prospecto) => {
    //       let nombre = prospecto.nombres;
    //       return arregloPalabras.some((p) => nombre.includes(p.toUpperCase()));
    //     });
    //   }
    // }
  },
  watch: {
    textoBusqueda() {
      if (this.editarMaster == false) {
        this.prospectos = [];
        this.listarProspectos();
      } else {
        this.masters = [];
        this.listarMasters();
      }
    },
    proyecto(value) {
      this.proyectoVentaId = value;
      if (this.editarMaster == false) {
        this.prospectos = [];
        this.listarProspectos();
      } else {
        this.masters = [];
        this.listarMasters();
      }
    }
  },
  created() {
    this.proyectoMaster(false);
  },
  mounted() {
    this.tipoUsuario = this.$store.getters.tipoUsuario;
    this.listarMasters();
  },
  methods: {
    async listarMasters() {
      this.cargandoMasters = true
      const params = {
        params: { ProyectoId: this.proyectoVentaId , Nombre: this.textoBusqueda }
      };
      try {
        const resp = await axios.get(rutaListarMasters, params);
        const obtenerMasters = resp.data.data;
        obtenerMasters.map(element => {
          let estatus = element.activo ? "ACTIVO" : "INACTIVO";
          this.masters.push({
            id: element.masterId,
            nombre: element.nombreCompleto,
            gerencia: element.gerencia,
            region: element.region,
            correo: element.correo,
            estatus: estatus
          });
        });
      } catch (error) {
        console.log(error);
      }finally{
        this.cargandoMasters = false
      }
    },
    async proyectoMaster(conEmbajadores) {
      const params = {
        params: { conEmbajadores }
      };
      try {
        const resp = await axios.get(rutaListarProyectos, params);
        const obtenerProyecto = resp.data.data;
        obtenerProyecto.map(element => {
          this.proyectos.push({
            nombre: element.nombre,
            proyectoVentaId: element.proyectoVentaId
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    //Inicio Ordenamiento Masters
    ordenarNombre() {
      this.ordenAscNombre = !this.ordenAscNombre;
      this.ordenAscGerencia = false;
      this.ordenAscRegion = false;
      this.ordenAscCorreo = false;
      this.ordenAscEstatus = false;
      if (this.ordenAscNombre) {
        let ordenar = (x, y) => {
          return x.nombre.localeCompare(y.nombre, "fr", {
            ignorePuntuaction: true
          });
        };
        this.masters.sort(ordenar);
      } else {
        let ordenar = (x, y) => {
          return x.nombre.localeCompare(y.nombre, "fr", {
            ignorePuntuaction: true
          });
        };
        this.masters.sort(ordenar).reverse();
      }
    },
    ordenarGerencia() {
      this.ordenAscGerencia = !this.ordenAscGerencia;
      this.ordenAscNombre = false;
      this.ordenAscRegion = false;
      this.ordenAscCorreo = false;
      this.ordenAscEstatus = false;
      if (this.ordenAscGerencia) {
        let ordenar = (x, y) => {
          return x.gerencia.localeCompare(y.gerencia, "fr", {
            ignorePuntuaction: true
          });
        };
        this.masters.sort(ordenar);
      } else {
        let ordenar = (x, y) => {
          return x.gerencia.localeCompare(y.gerencia, "fr", {
            ignorePuntuaction: true
          });
        };
        this.masters.sort(ordenar).reverse();
      }
    },
    ordenarRegion() {
      this.ordenAscRegion = !this.ordenAscRegion;
      this.ordenAscNombre = false;
      this.ordenAscGerencia = false;
      this.ordenAscCorreo = false;
      this.ordenAscEstatus = false;
      if (this.ordenAscRegion) {
        let ordenar = (x, y) => {
          return x.region.localeCompare(y.region, "fr", {
            ignorePuntuaction: true
          });
        };
        this.masters.sort(ordenar);
      } else {
        let ordenar = (x, y) => {
          return x.region.localeCompare(y.region, "fr", {
            ignorePuntuaction: true
          });
        };
        this.masters.sort(ordenar).reverse();
      }
    },
    ordenarCorreo() {
      this.ordenAscCorreo = !this.ordenAscCorreo;
      this.ordenAscNombre = false;
      this.ordenAscGerencia = false;
      this.ordenAscRegion = false;
      this.ordenAscEstatus = false;
      if (this.ordenAscCorreo) {
        let ordenar = (x, y) => {
          return x.correo.localeCompare(y.correo, "fr", {
            ignorePuntuaction: true
          });
        };
        this.masters.sort(ordenar);
      } else {
        let ordenar = (x, y) => {
          return x.correo.localeCompare(y.correo, "fr", {
            ignorePuntuaction: true
          });
        };
        this.masters.sort(ordenar).reverse();
      }
    },
    ordenarEstatus() {
      this.ordenAscEstatus = !this.ordenAscEstatus;
      this.ordenAscNombre = false;
      this.ordenAscGerencia = false;
      this.ordenAscRegion = false;
      this.ordenAscCorreo = false;
      if (this.ordenAscEstatus) {
        let ordenar = (x, y) => {
          return x.estatus.localeCompare(y.estatus, "fr", {
            ignorePuntuaction: true
          });
        };
        this.masters.sort(ordenar);
      } else {
        let ordenar = (x, y) => {
          return x.estatus.localeCompare(y.estatus, "fr", {
            ignorePuntuaction: true
          });
        };
        this.masters.sort(ordenar).reverse();
      }
    },
    //Inicio Ordenamiento Prospectos
    ordenarNombrePros() {
      this.ordenAscNombrePros = !this.ordenAscNombrePros;
      this.ordenAscEtapaPros = false;
      this.ordenAscRegionPros = false;
      this.ordenAscCorreoPros = false;
      this.ordenAscEstatusPros = false;
      if (this.ordenAscNombrePros) {
        let ordenar = (x, y) => {
          return x.nombre.localeCompare(y.nombre, "fr", {
            ignorePuntuaction: true
          });
        };
        this.prospectos.sort(ordenar);
      } else {
        let ordenar = (x, y) => {
          return x.nombre.localeCompare(y.nombre, "fr", {
            ignorePuntuaction: true
          });
        };
        this.prospectos.sort(ordenar).reverse();
      }
    },
    ordenarEtapaPros() {
      this.ordenAscEtapaPros = !this.ordenAscEtapaPros;
      this.ordenAscNombrePros = false;
      this.ordenAscRegionPros = false;
      this.ordenAscCorreoPros = false;
      this.ordenAscEstatusPros = false;
      if (this.ordenAscEtapaPros) {
        let ordenar = (x, y) => {
          return x.aliasEtapaStr.localeCompare(y.aliasEtapaStr, "fr", {
            ignorePuntuaction: true
          });
        };
        this.prospectos.sort(ordenar);
      } else {
        let ordenar = (x, y) => {
          return x.aliasEtapaStr.localeCompare(y.aliasEtapaStr, "fr", {
            ignorePuntuaction: true
          });
        };
        this.prospectos.sort(ordenar).reverse();
      }
    },
    ordenarRegionPros() {
      this.ordenAscRegionPros = !this.ordenAscRegionPros;
      this.ordenAscNombrePros = false;
      this.ordenAscEtapaPros = false;
      this.ordenAscCorreoPros = false;
      this.ordenAscEstatusPros = false;
      if (this.ordenAscRegionPros) {
        let ordenar = (x, y) => {
          return x.sucursal.localeCompare(y.sucursal, "fr", {
            ignorePuntuaction: true
          });
        };
        this.prospectos.sort(ordenar);
      } else {
        let ordenar = (x, y) => {
          return x.sucursal.localeCompare(y.sucursal, "fr", {
            ignorePuntuaction: true
          });
        };
        this.prospectos.sort(ordenar).reverse();
      }
    },
    ordenarCorreoPros() {
      this.ordenAscCorreoPros = !this.ordenAscCorreoPros;
      this.ordenAscNombrePros = false;
      this.ordenAscEtapaPros = false;
      this.ordenAscRegionPros = false;
      this.ordenAscEstatusPros = false;
      if (this.ordenAscCorreoPros) {
        let ordenar = (x, y) => {
          return x.usuario.localeCompare(y.usuario, "fr", {
            ignorePuntuaction: true
          });
        };
        this.prospectos.sort(ordenar);
      } else {
        let ordenar = (x, y) => {
          return x.usuario.localeCompare(y.usuario, "fr", {
            ignorePuntuaction: true
          });
        };
        this.prospectos.sort(ordenar).reverse();
      }
    },
    ordenarEstatusPros() {
      this.ordenAscEstatusPros = !this.ordenAscEstatusPros;
      this.ordenAscNombrePros = false;
      this.ordenAscEtapaPros = false;
      this.ordenAscRegionPros = false;
      this.ordenAscCorreoPros = false;
      if (this.ordenAscEstatusPros) {
        let ordenar = (x, y) => {
          return x.token.localeCompare(y.token, "fr", {
            ignorePuntuaction: true
          });
        };
        this.prospectos.sort(ordenar);
      } else {
        let ordenar = (x, y) => {
          return x.token.localeCompare(y.token, "fr", {
            ignorePuntuaction: true
          });
        };
        this.prospectos.sort(ordenar).reverse();
      }
    },
    nuevoPerfil() {
      this.editarMaster = true;
      this.$router.push({
        name: "AltaPerfil",
        params: { tipo: "M" }
      });
    },
    SeleccionaTipoUsuario(tipoUsuarioEditar) {
      this.textoBusqueda = "";
      this.proyecto = null;
      if (tipoUsuarioEditar == "M") {
        this.editarMaster = true;
        this.masters = [];
        this.listarMasters();
      } else {
        this.editarMaster = false;
        this.prospectos = [];
        this.listarProspectos();
      }
    },
    listarProspectos() {
      this.cargandoProspectos = true;
      const usuario = {
        params: {
          usuarioId: this.tipoUsuario,
          ProyectoId: this.proyectoVentaId,
          Nombre: this.textoBusqueda
        }
      }
      axios
        .get(rutaListarProspectosPorRol, usuario)
        .then(response => {
          if (response.data.estado === 0) {
            this.prospectos = response.data.data;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        })
        .finally(() => {
          this.cargandoProspectos = false;
        });
    },
    habilitarMaster(masterId, estatus) {
      console.log("Embajadores");
      console.log(estatus);
      let e = estatus == "ACTIVO" ? "desactivar" : "activar";
      console.log(e);
      this.$fire({
        title: "Cambiar Estatus",
        html: "¿Deseas " + e + " al usuario? <br>",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then(async result => {
            if (result.value) {
              let resultado = await this.CambiaEstatusUsuario(masterId, estatus);
                if (resultado) {
                  this.masters = [];
                  this.listarMasters();
                  this.AlertaEmbajadores(
                    "Se cambio el estatus correctamente.",
                    true
                  );
                } else {
                  this.AlertaEmbajadores(
                    "Ocurrio un error al intentar cambiar el estatus.",
                    true
                  );
                }
            }
          });
    },
    async CambiaEstatusUsuario(masterId, activo)
    {
      let estatus = activo == "ACTIVO" ? false : true;
      const params = {
        params: { masterId, estatus},
      };
      try {
        const resp = await axios.get(
          rutaActualizaUsuario,
          params
        );
        return resp.data.data;
      } catch (error) { console.log(error);}
    },
    editarPerfil(masterId, tipoUsuario) {
      this.$router.push({
        name: "EditarPerfil",
        params: { id: masterId, tipo: tipoUsuario },
      });
    },
    habilitarToken(UsuarioId, token) {
    console.log("Clientes");
    console.log(token);
    let e = token == "Vigente" ? "Expirar" : "Renovar";
    console.log(e);
       this.$fire({
            title: "Token",
            html:
              "¿Deseas " + e + " el token del usuario? <br>",
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
          }).then(async (result) => {
            if (result.value) {
              let resultado = await this.CambiaEstatusToken(UsuarioId, token);
                if (resultado) {
                  this.prospectos = [];
                  this.listarProspectos();
                  this.AlertaEmbajadores(
                    "Se cambio el estatus correctamente.",
                    true
                  );
                } else {
                  this.AlertaEmbajadores(
                    "Ocurrio un error al intentar cambiar el estatus.",
                    true
                  );
                }
            }
          });
    },
    async CambiaEstatusToken(usuarioId, activo)
    {
      let estatus = activo == "Vigente" ? false : true;
      const params = {
        params: { usuarioId, estatus},
      };
      try {
        const resp = await axios.get(
          rutaActualizarTokenUsuario,
          params
        );
        return resp.data.data;
      } catch (error) { console.log(error);}
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";
$color-primario: #b8725a;
$blanco: #ffffff;
$negro-embajadores: #1e2120;
$poppins: "Poppins";
$borde-campo: #707070;

.administrador {
  background: url("https://hircasageneral.blob.core.windows.net/embajadores-manager/img/images/img_admon.png") no-repeat
    center center fixed;
  background-size: cover;
  width: 100vw;
  flex-grow: 1;
}
.titulo-admin {
  color: $blanco;
  text-align: left;
}
.boton-primario {
  border-radius: 0px !important;
  background-color: $color-primario !important;
  box-shadow: none !important;
  color: $blanco !important;
  font-family: $poppins !important;
}
.boton-primario:hover {
  color: $blanco !important;
  background-color: #a56651 !important;
}
.boton-primario:focus {
  box-shadow: none !important;
}
.campo-administracion {
  border-radius: 0px !important;
  border-style: none !important;
  font-family: $poppins !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 18px !important;
  letter-spacing: 0.05em !important;
  height: 40px !important;
}
.wrapper-busqueda .icono-busqueda {
  position: absolute;
}

.wrapper-busqueda {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.icono-busqueda {
  padding-top: 12px;
  padding-right: 12px;
  color: $color-primario;
  font-size: 18px;
  opacity: 0.8;
}
.dropdown {
  background: rgb(255, 255, 255) !important;
}
.estatus {
  text-align: center;
  padding: 5px;
  border-radius: 25px;
}
.estatus-activo {
  border-radius: 25px !important;
  border: 1px solid #51bfa6 !important;
  color: #51bfa6 !important;
  font-weight: 500 !important;
  padding: 5px !important;
  text-align: center !important;
}
.estatus-inactivo {
  border-radius: 25px !important;
  border: 1px solid #959696 !important;
  color: #959696 !important;
  font-weight: 500 !important;
  padding: 5px !important;
  text-align: center !important;
}
.dropdown-table {
  color: white !important;
}
.seleccionar-elemento {
  cursor: pointer;
}
.seleccionar-elemento:hover {
  color: rgb(0, 0, 0, 0.6);
}
</style>
